<template>
    <div class="fill-height d-flex flex-column of-y" >
        <app-admin-company-information ref="0" v-if="$store.state.ref.admin.tabIndex === 0"/>
<!--        <app-admin-billing ref="1" v-if="$store.state.ref.admin.tabIndex === 1"/>-->
        <app-admin-invoices ref="1" v-if="$store.state.ref.admin.tabIndex === 1"/>
<!--        <app-dashboard-teams ref="1" v-if="$store.state.ref.dashboard.tabIndex === 1"/>-->
<!--        <app-dashboard-employees ref="2" v-if="$store.state.ref.dashboard.tabIndex === 2"/>-->
<!--        <app-dashboard-apps ref="3" v-if="$store.state.ref.dashboard.tabIndex === 3"/>-->
    </div>
</template>

<script>


import AppDashboardEmployees from "@/components/Dashboard/AppDashboardEmployees";
import AppDashboardTeams from "@/components/Dashboard/AppDashboardTeams";
import AppDashboardApps from "@/components/Dashboard/AppDashboardApps";
import AppDashboardLanding from "@/components/Dashboard/AppDashboardLanding";
import AppAdminToolbar from "@/components/Admin/AppAdminToolbar";
import AppAdminCompanyInformation from "@/components/Admin/AppAdminCompanyInformation";
import AppAdminInvoices from "@/components/Admin/AppAdminInvoices";
import AppAdminBilling from "@/components/Admin/AppAdminBilling";
export default {
    components: {AppAdminBilling, AppAdminInvoices, AppAdminCompanyInformation, AppAdminToolbar},
    props: {

    },
    data() {
        return {

        }
    },
    watch: {

    },
    computed: {

    },
}
</script>

<style scoped>

</style>